import React, { useState } from 'react';
import createContainer from 'constate';
import { nameHOC } from './hocutils';

function useRatingsContextHook({ data: initialRatingsData }) {
  const [ratings, setRatings] = useState(initialRatingsData);

  return {
    ratings,
    setRatings,
  };
}

const [RatingsProvider, useRatings] = createContainer(useRatingsContextHook);

const withRatings = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;
  const ComponentWithRatingsData = (props) => {
    const ratingDataWithState = useRatings();
    return <WrappedComponent {...props} ratings={ratingDataWithState} />;
  };

  if (typeof getInitialProps === 'function') {
    ComponentWithRatingsData.getInitialProps = getInitialProps;
  }

  ComponentWithRatingsData.originalName = nameHOC(WrappedComponent);
  ComponentWithRatingsData.displayName = nameHOC(WrappedComponent, 'WithRatings');
  return ComponentWithRatingsData;
};

export { withRatings, RatingsProvider, useRatings };
